import { Image } from '@frontendmentorio/design-system-v2';

export default function PaymentMethods() {
  return (
    <div className="bg-gray-100 p-5 rounded-lg w-fit">
      <h3 className="sr-only">Accepted payment methods</h3>

      <ul className="flex flex-wrap gap-4 justify-center">
        <li>
          <Image
            alt="Visa"
            height={40}
            src="/static/images/visa.png"
            width={60}
          />
        </li>

        <li>
          <Image
            alt="MasterCard"
            height={40}
            src="/static/images/mastercard.png"
            width={60}
          />
        </li>

        <li>
          <Image
            alt="American Express"
            height={40}
            src="/static/images/amex.png"
            width={60}
          />
        </li>

        <li>
          <Image
            alt="Maestro"
            height={40}
            src="/static/images/maestro.png"
            width={60}
          />
        </li>

        <li>
          <Image
            alt="PayPal"
            height={40}
            src="/static/images/paypal.png"
            width={60}
          />
        </li>

        <li>
          <Image
            alt="Google Pay"
            height={40}
            src="/static/images/gpay.png"
            width={60}
          />
        </li>
      </ul>
    </div>
  );
}
